import { render, staticRenderFns } from "./ScanComplete.vue?vue&type=template&id=720f10c9&scoped=true&"
import script from "./ScanComplete.vue?vue&type=script&lang=js&"
export * from "./ScanComplete.vue?vue&type=script&lang=js&"
import style0 from "./ScanComplete.vue?vue&type=style&index=0&id=720f10c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720f10c9",
  null
  
)

export default component.exports